/* tslint:disable */
/* eslint-disable */
/**
 * WeighMed Backend APIs - OpenAPI 3.0
 * You can find out more about Swagger at [https://editor.swagger.io/](https://editor.swagger.io/).
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface VRefreshRequestParams
 */
export interface VRefreshRequestParams {
    /**
     * The refresh token got from the reponse of the login API
     * @type {string}
     * @memberof VRefreshRequestParams
     */
    refreshToken: string;
}

/**
 * Check if a given object implements the VRefreshRequestParams interface.
 */
export function instanceOfVRefreshRequestParams(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "refreshToken" in value;

    return isInstance;
}

export function VRefreshRequestParamsFromJSON(json: any): VRefreshRequestParams {
    return VRefreshRequestParamsFromJSONTyped(json, false);
}

export function VRefreshRequestParamsFromJSONTyped(json: any, ignoreDiscriminator: boolean): VRefreshRequestParams {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'refreshToken': json['refreshToken'],
    };
}

export function VRefreshRequestParamsToJSON(value?: VRefreshRequestParams | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'refreshToken': value.refreshToken,
    };
}

